import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ButtonBlue from "../../../shared/general/ButtonBlue";
import { useDispatch, useSelector } from "react-redux";
import { getAllEmployees } from "../../../../../actions/employee";
import {
  getOnBoardingEmployee,
  getOnBoardingEmployeeByID,
} from "../../../../../actions/onBoarding";
import More from "./viewmore";

const StyledWrapBranch = styled("div")({
  marginBottom: 36,
  "& .wrap-branch-top": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
    "& .MuiTypography-body2": {
      margin: 0,
    },
  },
  "& .branch-scroll": {
    height: 280,
    overflow: "auto",
  },
  "& .action": {
    textAlign: "right",
    "& .fal": {
      fontSize: 18,
    },
  },
  "& .address": {
    fontWeight: 600,
    fontSize: 18,
  },
  "& .contact": {
    "& .fal": {
      marginRight: 8,
    },
  },
});

const StatusOnBoarding = () => {
  const dispatch = useDispatch();
  const { result: onBoardingEmployee } = useSelector((state) => state.onBoardingEmployee);
  const [OpenMore, setOpenMore] = useState(false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    dispatch(getAllEmployees());
    dispatch(getOnBoardingEmployee());
  }, []);

  const handleOpenMore = (data) => {
    if (OpenMore === false || data !== formData) {
      setOpenMore(true);
      setFormData(data);
      dispatch(getOnBoardingEmployeeByID(data.idEmployees));
    } else handleClose();
  };

  const handleClose = () => {
    setOpenMore(false);
    setFormData(null);
  };

  return (
    <div>
      <StyledWrapBranch>
        {onBoardingEmployee && onBoardingEmployee.length > 0 ? (
          <div>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 600 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"> </TableCell>
                    <TableCell align="center">ชื่อ</TableCell>
                    <TableCell align="center">ตำแหน่ง</TableCell>
                    <TableCell align="center">หน่วยงาน</TableCell>
                    <TableCell align="center">สถานะ</TableCell>
                    <TableCell align="center">รายละเอียด</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {onBoardingEmployee.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{index + 1} </TableCell>
                      <TableCell align="center">
                        {`${row.firstname_TH}   ${row.lastname_TH}`}{" "}
                      </TableCell>
                      <TableCell align="center">{row.positionName} </TableCell>
                      <TableCell align="center">
                        {row.departmentName}{" "}
                      </TableCell>
                      <TableCell align="center">{`${row.status}  %`}</TableCell>
                      <TableCell align="center">
                        <ButtonBlue
                          size="small"
                          startIcon={<ExpandMoreIcon />}
                          onClick={() => handleOpenMore(row)}
                        ></ButtonBlue>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : (
          "ไม่มีรายการ"
        )}
      </StyledWrapBranch>

      {OpenMore && <More data={formData} />}
    </div>
  );
};

export default StatusOnBoarding;
